export default __webpack_public_path__ + "static/media/Bubble3Small.d9536953.svg";